import type { Seo } from '@content/types';
import type { PageHead } from './head';

/** The <head> tags Webflow emitted for CMS item pages. */
export function cmsHead(seo: Seo, path: string, extraLinks: PageHead['links'] = []): PageHead {
  const meta: PageHead['meta'] = [{ title: seo.title }, { name: 'description', content: seo.description }];
  meta.push({ property: 'og:title', content: seo.title }, { property: 'og:description', content: seo.description });
  if (seo.image) meta.push({ property: 'og:image', content: seo.image });
  meta.push({ name: 'twitter:title', content: seo.title }, { name: 'twitter:description', content: seo.description });
  if (seo.image) meta.push({ name: 'twitter:image', content: seo.image });
  meta.push({ property: 'og:type', content: 'website' }, { name: 'twitter:card', content: 'summary_large_image' });
  return {
    meta,
    links: [{ href: `https://www.dbos.dev${path}`, rel: 'canonical' }, ...extraLinks],
    scripts: seo.jsonLd ? [{ type: 'application/ld+json', children: seo.jsonLd }] : [],
  };
}
